import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';
import { resolveFederationManifest } from './app/plugin/federation-manifest-resolver';
import { recordComposedRemotes } from './app/plugin/composed-remotes';

resolveFederationManifest(environment, window.location.search)
  .then((manifest) => {
    recordComposedRemotes(manifest);
    return initFederation(manifest);
  })
  .catch(err => console.error(err))
  .then(() => import('./bootstrap'))
  .catch(err => console.error(err));
